// ============================================================
//  Badge.jsx — Status badge component
// ============================================================
const statusConfig = {
  PENDING_VERIFIKASI: { label: "Menunggu Verifikasi",  color: "#D97706", bg: "#FFFBEB", border: "#FDE68A" },
  PENDING_APPROVAL:   { label: "Menunggu Persetujuan", color: "#EA580C", bg: "#FFF7ED", border: "#FDBA74" },
  DISETUJUI:          { label: "Disetujui",            color: "#059669", bg: "#ECFDF5", border: "#6EE7B7" },
  DITOLAK:            { label: "Ditolak",              color: "#DC2626", bg: "#FEF2F2", border: "#FECACA" },
  SELESAI:            { label: "Selesai",              color: "#1D4ED8", bg: "#EFF6FF", border: "#93C5FD" },
  TERPOSTING:         { label: "Terposting",           color: "#1D4ED8", bg: "#EFF6FF", border: "#93C5FD" },
  COMPLETED:           { label: "Selesai",              color: "#059669", bg: "#ECFDF5", border: "#6EE7B7" },
  DRAFT:              { label: "Draft",                color: "#6B7280", bg: "#F9FAFB", border: "#D1D5DB" },
  AKTIF:              { label: "Aktif",                color: "#059669", bg: "#ECFDF5", border: "#6EE7B7" },
  Aktif:              { label: "Aktif",                color: "#059669", bg: "#ECFDF5", border: "#6EE7B7" },
  NONAKTIF:           { label: "Nonaktif",             color: "#6B7280", bg: "#F9FAFB", border: "#D1D5DB" },
  DALAM_PERBAIKAN:    { label: "Perbaikan",            color: "#D97706", bg: "#FFFBEB", border: "#FDE68A" },
  DALAM_PEMINDAHAN:   { label: "Pemindahan",          color: "#7C3AED", bg: "#EDE9FE", border: "#C4B5FD" },
  TIDAK_AKTIF:        { label: "Tidak Aktif",         color: "#6B7280", bg: "#F9FAFB", border: "#D1D5DB" },
  DIHAPUSKAN:         { label: "Dihapuskan",           color: "#DC2626", bg: "#FEF2F2", border: "#FECACA" },
  Dihapuskan:         { label: "Dihapuskan",           color: "#DC2626", bg: "#FEF2F2", border: "#FECACA" },
  PENERIMAAN:         { label: "Penerimaan",           color: "#059669", bg: "#ECFDF5", border: "#6EE7B7" },
  PENGELUARAN:        { label: "Pengeluaran",          color: "#DC2626", bg: "#FEF2F2", border: "#FECACA" },
  PAYMENT_REQUEST:    { label: "Payment Request",      color: "#D97706", bg: "#FFFBEB", border: "#FDE68A" },
  DIPROSES:           { label: "Diproses",             color: "#D97706", bg: "#FFFBEB", border: "#FDE68A" },
  MENUNGGU:           { label: "Menunggu",             color: "#6B7280", bg: "#F9FAFB", border: "#D1D5DB" },
  GAGAL:              { label: "Gagal",                color: "#DC2626", bg: "#FEF2F2", border: "#FECACA" },
  Baik:               { label: "Baik",                color: "#059669", bg: "#ECFDF5", border: "#6EE7B7" },
  Sedang:             { label: "Sedang",              color: "#D97706", bg: "#FFFBEB", border: "#FDE68A" },
  Rusak:              { label: "Rusak",               color: "#DC2626", bg: "#FEF2F2", border: "#FECACA" },
  Hilang:             { label: "Hilang",              color: "#7C3AED", bg: "#EDE9FE", border: "#C4B5FD" },
};

const Badge = ({ status }) => {
  const c = statusConfig[status] || statusConfig.DRAFT;
  return (
    <span style={{
      padding: "2px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600,
      color: c.color, background: c.bg, border: `1px solid ${c.border}`, whiteSpace: "nowrap"
    }}>
      {c.label}
    </span>
  );
};

export default Badge;